import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supplyApi, type SupplyQuery } from '../api/supply.api.js';

/**
 * So'rov kalitlari — SHAKLNI nomlaydi.
 *
 * Sabab `features/org/model/org.queries.ts` da yozilgan: bir xil kalit
 * ostida ikki xil shakl yashagan joyda sahifa `.filter is not a function`
 * bilan qulagan edi.
 */
export const supplyKeys = {
  all: ['supply'] as const,
  list: (query: SupplyQuery) => ['supply', 'list', query] as const,
  detail: (id: string) => ['supply', 'detail', id] as const,
};

export const useSupplyReports = (query: SupplyQuery = {}) =>
  useQuery({
    queryKey: supplyKeys.list(query),
    queryFn: () => supplyApi.list(query),
  });

/**
 * Hujjat va uning ish ro'yxati.
 *
 * `staleTime` NOL: `toPlaceQty` omborning hozirgi holatidan hisoblanadi va
 * boshqa skladchi shu orada joylashtirgan bo'lishi mumkin. Eskirgan son
 * bu yerda "joylashtirish mumkin" deb ko'rsatib, keyin serverdan xato
 * oldirardi.
 */
export const useSupplyReport = (id: string | null) =>
  useQuery({
    queryKey: supplyKeys.detail(id ?? ''),
    queryFn: () => supplyApi.getById(id ?? ''),
    enabled: id !== null && id !== '',
    staleTime: 0,
  });

/**
 * Qoralamani yuborish va o'chirish — buxgalterning ikki tugmasi.
 *
 * Ikkalasi ham butun `supply` daraxtini yangilaydi: ro'yxatdagi kartochka
 * ham, ochiq turgan hujjat ham o'zgaradi.
 */
const useSupplyAction = (action: (id: string) => Promise<void>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: supplyKeys.all });
    },
  });
};

export const useSendSupply = () => useSupplyAction((id) => supplyApi.send(id));

export const useDeleteSupply = () => useSupplyAction((id) => supplyApi.remove(id));
